<template>
  <el-card class="webview-main">
    <iframe class="iframe" :src="url"></iframe>
  </el-card>
</template>

<script>
export default {
  name: 'Webview',
  data () {
    return {}
  },
  computed: {
    url () {
      return this.$route.query.url
    }
  },
  watch: {
  },
  created () {
    // do something
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.webview-main {
  height: calc(100vh - 130px);

  ::v-deep {
    .el-card__body {
      height: 100%;
    }
  }
}

.iframe {
  border: 0;
  width: 100%;
  height: 100%;
  vertical-align: top;
}
</style>
